import { frontendURL } from 'dashboard/helper/URLHelper.js';
import CrmIndex from './pages/CrmIndex.vue';

// CRM Recompra (Vincto). Gateado por permissao (admin), nao por feature flag
// (o bigint de feature_flags ja estourou). O item de sidebar tem gate por conta
// via account.settings.crm_enabled.
const meta = {
  permissions: ['administrator'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm'),
    name: 'crm_index',
    meta,
    component: CrmIndex,
  },
  {
    path: frontendURL('accounts/:accountId/crm/calendar'),
    name: 'crm_calendar',
    meta: {
      // Agenda e pra equipe toda (a policy do backend escopa por papel)
      permissions: ['administrator', 'agent'],
    },
    // LAZY de proposito: FullCalendar (~250KB) fica num chunk separado que so
    // carrega ao abrir a Agenda. Nao importar @fullcalendar/* fora desta subarvore.
    component: () => import('./calendar/CalendarPage.vue'),
  },
];
